module.exports = __webpack_public_path__ + "static/img/btn2.d37ba17.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/background/btn2.png
// module id = IOib
// module chunks = 1